




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

export enum GroupButtonPredefinedStyle {
    Horizontal = 'group-button--horizontal',
    Vertical = 'group-button--vertical',
}

@Component
export default class GroupButton extends Vue {
    @Prop( { default: GroupButtonPredefinedStyle.Horizontal } ) private groupButtonPredefinedStyle !: GroupButtonPredefinedStyle;
    @Prop( { default: '' } ) private groupButtonError !: string;
    @Prop( { default: 'text' } ) private labelField !: string;
    @Prop( { default: () => ([{ id: '-1', text: 'Default option' }]) } ) private options!: any[];
    @Prop( { default: '-1' } ) private groupButtonValue!: string;
    @Prop( { default: false } ) private disabled!: boolean;
    @Prop( { default: false } ) private squad!: boolean;


    private optionSelected: any = {};


    @Watch('groupButtonValue')
    private watchGroupButtonValue(newVal: any, oldVal: any) {
        this.assignOptionSelected();
    }


    private created() {
        this.assignOptionSelected();
    }


    get hasError() {
        return this.groupButtonError !== '';
    }


    private hideError() {
        this.$emit('hide-error');
    }

    private isOptionSelected(option: any) {
        return this.optionSelected && this.optionSelected.id === option.id;
    }

    private selectOption(option: any) {
        if ( !this.disabled ) {
            this.hideError();
            this.$emit('input', option.id);
            this.$emit('option-selected', option.id);
        }
    }

    private assignOptionSelected() {
        const optionFinded = this.options.find((option: any) => {
            return option.id === this.groupButtonValue;
        });

        this.optionSelected = Object.assign( {}, optionFinded );
    }
}
